import { Helper } from './../helpers/helper';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import 'rxjs/add/operator/map';

@Injectable()
export class MapService {
  constructor( private http: HttpClient, public helper: Helper ) {}

  tableroMapa(mapa?, ruta?, fecha?) {
    let params = new HttpParams();
    if (fecha) {
      params = params.append('fecha', fecha);
    }
    if (mapa) {

      params = params.append('mapa', mapa);
    }
    if (ruta) {
      params = params.append('ruta', ruta);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/tablero-mapa`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/services/map.service.ts